module.exports = __webpack_public_path__ + "img/event_day2_1000.81517406.png";